import axios from "axios";
export default {
  namespaced: true,
  state: {
    headers: [{
        text: "Técnico",
        alias: "tecnico",
        align: "start",
        filterable: true,
        sortable: true,
        value: "user.name",
        width: "5%"
      },
      {
        text: "Tipo acción",
        alias: "tipoAccion",
        filterable: true,
        sortable: true,
        value: "contrato.contrato",
        width: "7%"
      },
      {
        text: "Ámbito",
        alias: "ambito",
        filterable: true,
        sortable: true,
        value: "ambito.ambito",
        width: "6%"
      },
      {
        text: "Urgencia",
        alias: "urgencia",
        filterable: true,
        sortable: true,
        value: "urgencia.urgencia",
        width: "6%"
      },
      {
        text: "Fecha",
        alias: "fecha",
        filterable: true,
        sortable: true,
        value: "fecha",
        width: "5%"
      },
      {
        text: "Entrada",
        alias: "entrada",
        filterable: false,
        sortable: false,
        value: "entrada",
        width: "5%"
      },
      {
        text: "Salida",
        alias: "salida",
        filterable: false,
        sortable: false,
        value: "salida",
        width: "5%"
      },
      {
        text: "Comentarios",
        alias: "comentarios",
        filterable: true,
        sortable: false,
        value: "comentarios",
        width: "40%"
      },
      {
        text: "Desp",
        alias: "desp",
        filterable: false,
        sortable: false,
        value: "desplazamiento",
        width: "2%"
      },
      {
        text: "Asis min",
        alias: "asistenciaMinima",
        filterable: false,
        sortable: false,
        value: "asistencia_minima",
        width: "2%"
      },
      {
        text: "",
        alias: "acciones",
        filterable: false,
        sortable: false,
        value: "acciones",
        width: "8%"
      },
    ],
    parte: []
  },
  mutations: {
    SET_PARTE(state, value) {
      state.parte = value
    }
  },
  actions: {
    // getHeaders({
    //   state
    // }, {
    //   ...params
    // }) {

    //   console.log(params);
    //   console.log(params.length ?
    //     state.headers.filter(header => (params[0] !== "-") === params.includes(header.alias)) :
    //     state.headers);
    //   return params.length ?
    //     state.headers.filter(header => (params[0] !== "-") === params.includes(header.alias)) :
    //     state.headers
    // }
    async recargarAccionesFidelizaciones({commit, dispatch, getters}) {
      let parte = getters.parte
      try {
        let respuesta = await axios.get(`/api/partes/${parte.id}`);
        parte.acciones = respuesta.data.acciones;
        parte.fidelizaciones = respuesta.data.fidelizaciones;
      } catch (error) {
        console.log(error);
        dispatch('setSnackbar', {
          tipo: "error",
          mensaje: "Error. No se han podido recargar las acciones y fidelizaciones",
        }, {
            root: true
        })
      }
      parte.accionesEliminadas = [];
      parte.accionesModificadas = [];
      parte.fidelizacionesEliminadas = [];
      parte.fidelizacionesModificadas = [];
      commit('SET_PARTE', parte)
    },
    setParte({commit}, {parte}) {
      commit('SET_PARTE', parte)
    },
    async guardarParte({dispatch, state}, recargarAcciones = false) {
      try {
        if (state.parte.id) { // Actualizar parte
          await axios.patch(`/api/partes/${state.parte.id}`, state.parte);
        }else{ // Crear parte
          let res = await axios.post("/api/partes", state.parte);
          let parte  = state.parte
          parte.id = res.data.id;
          parte.numParte = res.data.numParte;
          dispatch('setParte',{parte})
        }
        if(!recargarAcciones) {
          dispatch('recargarAccionesFidelizaciones')
        }
        dispatch('setSnackbar', {
          tipo: "success",
          mensaje: "Datos guardados correctamente",
        }, {
            root: true
        })
      } catch (error) {
        console.log(error);
        dispatch('setSnackbar', {
          tipo: "error",
          mensaje: "Error. No se han podido guardar los datos",
        }, {
            root: true
        })
      }
    },
  },
  getters: {
    // headers2: state => (...params) => {
    //   return params.length ? 
    //           state.header.filter(header => (params[0] !== "-") === params.includes(header.alias))  
    //           : state.header
    // },
    headers2: state => {
      const filtros = ['tecnico', 'tipoAccion', 'ambito', 'fecha', 'comentarios']
      return state.headers.filter(header => filtros.includes(header.alias))
    },
    headers: state => state.headers,
    parte: state => state.parte
  }
}